import * as Sentry from "@sentry/react"
import { createFilename } from "@src/filepath"
import axios, { HttpStatusCode } from "axios"

import C from "../Controller"

// Polyfill for __filename since it's not available in browser environment
const __filename = createFilename("ControllerModules/Middletier.ts")

export const getCSRFToken = async () => {
  if (axios.defaults.headers.post["X-CSRF-Token"]) {
    return axios.defaults.headers.post["X-CSRF-Token"]
  }
  const response = await axios.get("/getCSRFToken")
  axios.defaults.headers.post["X-CSRF-Token"] = response.data.CSRFToken
  return response.data.CSRFToken
}

export const xhrPost = (
  url: string,
  payload: string,
  callback: (reponse: any) => void,
  onError?: any,
  extraHeaders: Record<string, string> = {},
) => {
  const transactionId = Math.random().toString(36).substr(2, 9)
  Sentry.configureScope((scope) => {
    scope.setTag("transaction_id", transactionId)
  })
  axios({
    method: "post",
    url: `/api${url}`,
    headers: {
      "Content-Type": "application/json",
      "X-Transaction-ID": transactionId,
      ...extraHeaders,
    },
    data: payload,
  })
    .then((response) => {
      if (callback) {
        callback(response.data)
      }
    })
    .catch((error) => {
      if (error.response?.status === HttpStatusCode.Unauthorized) {
        window.location.replace("/")
      }
      if (onError) {
        onError(error)
      }
      C.serverLog({
        level: "error",
        message: `Middletier request error: ${error}`,
        filename: __filename,
        endpoint: `${url}`,
        payload,
      })
    })
}

/* Generic Request */

export const fetchData = (
  fileName: string,
  callback: (success: boolean, data: string) => void,
) => {
  fetch(fileName)
    .then((res) => {
      if (res.status === HttpStatusCode.Unauthorized) {
        window.location.replace("/")
      }
      return res.text()
    })
    .then(
      (data) => {
        callback(true, data)
      },
      (error) => {
        callback(false, error)
        C.serverLog({
          level: "error",
          message: "Fetch Data Failed",
          filename: __filename,
          endpoint: `${fileName}`,
          payload: error,
        })
      },
    )
    .catch((reason: any) => {
      callback(false, reason)
      C.serverLog({
        level: "error",
        message: "Fetch Data Failed",
        filename: __filename,
        endpoint: `${fileName}`,
        payload: reason,
      })
    })
}

export const fetchJson = (
  url: string,
  callback: (success: boolean, data: any) => void,
) => {
  fetch(`/api${url}`, {})
    .then((res) => {
      if (res.status === HttpStatusCode.Unauthorized) {
        window.location.replace("/")
      }
      return res.json()
    })
    .then(
      (data) => {
        callback(true, data)
      },
      (error) => {
        callback(false, error)
        C.serverLog({
          level: "error",
          message: "Middletier request error",
          filename: __filename,
          endpoint: `${url}`,
          stack: `${error}`,
        })
      },
    )
    .catch((reason: any) => {
      callback(false, reason)
      C.serverLog({
        level: "error",
        message: "Fetch Data Failed",
        filename: __filename,
        endpoint: `${url}`,
        payload: reason,
      })
    })
}
